import { createStandardAction } from 'typesafe-actions';

const LOCALE_SETTINGS_CHANGE_LOCALE = 'LOCALE_SETTINGS_CHANGE_LOCALE';
const LOCALE_SETTINGS_LOAD_MESSAGES = 'LOCALE_SETTINGS_LOAD_MESSAGES';

export const localeSettingsChangeLocale = createStandardAction(LOCALE_SETTINGS_CHANGE_LOCALE)<any>();
export const localeSettingsLoadMessages = createStandardAction(LOCALE_SETTINGS_LOAD_MESSAGES)<any>();



// WEBPACK FOOTER //
// ./src/containers/LocaleSettings/actions.ts